import { component } from 'picoapp';

export default component(async (node) => {
  const triggers = node.querySelectorAll<HTMLAnchorElement>('[data-group-trigger]');
  const groupLinks = node.querySelectorAll<HTMLElement>('[data-faq-group-link');

  const initTriggers = () => {
    triggers.forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();

        triggers.forEach((otherTrigger) => {
          otherTrigger.classList[otherTrigger === trigger ? 'add' : 'remove']('button--primary');
          otherTrigger.classList[otherTrigger === trigger ? 'remove' : 'add']('button--tertiary');
          otherTrigger.parentElement.classList[otherTrigger === trigger ? 'add' : 'remove']('active');
        });

        const target = Array.from(groupLinks).find((link) => (
          trigger.hash.replace('#', '') === link.id
        ));

        groupLinks.forEach((link) => {
          link.hidden = link !== target;
        });
      });
    });
  };

  const initQuestionLinks = () => {
    groupLinks.forEach((groupLink) => {
      const questionLinks = groupLink.querySelectorAll<HTMLElement>('[data-faq-question-link');
      const answerLinks = groupLink.querySelectorAll<HTMLElement>('[data-faq-answer-link]');

      questionLinks.forEach((questionLink) => {
        const match = Array.from(answerLinks).find((answerLink) => (
          questionLink.dataset.faqQuestionLink === answerLink.dataset.faqAnswerLink
        ));

        questionLink.addEventListener('click', () => {
          questionLinks.forEach((otherQuestionLink) => {
            otherQuestionLink.classList[otherQuestionLink === questionLink ? 'add' : 'remove']('md:active');
          });

          answerLinks.forEach((answerLink) => {
            answerLink.hidden = answerLink !== match;
          });
        });
      });
    });
  };

  const init = () => {
    initTriggers();
    initQuestionLinks();
  };

  init();
});
